export const getDealStatusLabel = (status: string) => {
  if (status === 'ReadyForActivation') {
    return 'Publishing';
  } else {
    return status;
  }
};
